import { JsonObject, JsonProperty } from 'json2typescript'

@JsonObject('QuoteAuthRequest')
export default class QuoteAuthRequest {
  @JsonProperty('guid', String)
  guid = ''
}
